import React from 'react';
import cn from 'classnames';

const NETWORK_EDGE_PRIORITY = {
  'Firewall': 0,
  'Routing': 1,
  'SD-WAN': 2,
  'Edge Data': 3,
};

const getNetworkEdgePriority = (infraComponent) => {
  return NETWORK_EDGE_PRIORITY[infraComponent.name] ?? 4;
};

const DeploymentContainer = ({ name, individual = false, icon, sectionInfraComponent, iconSize }) => {
  const sortedArray =
    name === 'Network Edge'
      ? sectionInfraComponent
          ?.map((infraComponent, index) => ({ infraComponent, index }))
          .sort((current, next) => {
            const priorityDiff = getNetworkEdgePriority(current.infraComponent) - getNetworkEdgePriority(next.infraComponent);

            return priorityDiff || current.index - next.index;
          })
          .map(({ infraComponent }) => infraComponent)
      : sectionInfraComponent?.sort();

  return (
    <div className={cn({ 'deployment-container': individual })}>
      <div className={cn('deployment-title', { smallTitle: iconSize < 0.7 }, { 'individual-title': individual })}>
        {icon} {name} <span className="amount-number">{iconSize < 0.7 && sectionInfraComponent.length}</span>
      </div>
      {iconSize >= 0.7 &&
        sortedArray?.map(
          (infraComponent) =>
            infraComponent.isVisible && (
              <div className="infraComponent-information" key={infraComponent.name}>
                <p className="infraComponent-name">{infraComponent.name}</p>
                <p className="infraComponent-device">{infraComponent.device}</p>
              </div>
            )
        )}
    </div>
  );
};

export default DeploymentContainer;
